var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "compliance-impersonate-page"
    },
    [
      _c("h2", { staticClass: "title typographies-heading-h2" }, [
        _c("span", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Mon Support Sellsy")) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isConsentEnabled
        ? _c("h3", { staticClass: "subtitle typographies-heading-h3" }, [
            _c("span", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__("Autoriser Sellsy à acceder à mon compte")
                  ) +
                  "\n        "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isConsentEnabled
        ? _c("p", {
            staticClass: "introduction typographies-paragraph-medium-regular",
            domProps: { innerHTML: _vm._s(_vm.introductionContent) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isConsentEnabled
        ? _c(
            "div",
            { staticClass: "pending-authorizations" },
            [
              _vm._l(_vm.pendingAuthorizations, function(
                pendingAuthorization,
                index
              ) {
                return _c("Notification", {
                  key: index,
                  attrs: { authorization: pendingAuthorization },
                  on: {
                    "accept-success": _vm.getUserAuthorizations,
                    "refuse-success": _vm.getUserAuthorizations
                  }
                })
              }),
              _vm._v(" "),
              !_vm.pendingAuthorizations.length
                ? _c(
                    "div",
                    { staticClass: "pending-authorizations__empty" },
                    [
                      _c("CompassIcon", { attrs: { icon: "clock" } }),
                      _vm._v(" "),
                      _c("p", { staticClass: "typographies-heading-h4" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$l10n.__("Pas de demande d'accès en attente")
                            ) +
                            "\n            "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLogActionsEnabled
        ? _c("section", { staticClass: "sellsy-actions-history" }, [
            _c("h3", { staticClass: "subtitle typographies-heading-h3" }, [
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Historique des actions Sellsy")) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass:
                "sellsy-actions-history__text typographies-paragraph-medium-regular",
              domProps: { innerHTML: _vm._s(_vm.sellsyActionsText) }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sellsy-actions-history__button" },
              [
                _vm.isAdmin
                  ? [
                      _c(
                        "CompassMenu",
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__(
                                "pages.settings.complianceImpersonate.ComplianceImpersonate.download_actions"
                              ),
                              loading: _vm.downloadInProgress,
                              type: "secondary",
                              dropdown: ""
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "dropdown" },
                            [
                              _c("CompassMenuItem", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "pages.settings.complianceImpersonate.ComplianceImpersonate.from_your_account"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDownload("me")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("CompassMenuItem", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "pages.settings.complianceImpersonate.ComplianceImpersonate.from_support"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDownload("support")
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ]
                  : [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__(
                            "pages.settings.complianceImpersonate.ComplianceImpersonate.download_actions"
                          ),
                          loading: _vm.downloadInProgress,
                          type: "secondary",
                          leftIcon: "download"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDownload("me")
                          }
                        }
                      })
                    ]
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isConsentEnabled
        ? _c(
            "section",
            { staticClass: "history-access-authorisations" },
            [
              _c("h3", { staticClass: "subtitle typographies-heading-h3" }, [
                _c("span", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__("Historique des autorisations d’accès")
                      ) +
                      "\n            "
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.authorizationsWithoutPending.length || _vm.loading
                ? _c(
                    "el-table",
                    {
                      ref: "tableHistoryAccessAuthorisations",
                      staticClass: "page-table",
                      attrs: {
                        "data-test": "tableHistoryAccessAuthorisations",
                        data: _vm.sortTableByDate,
                        "max-height": "613",
                        headerCellClassName:
                          "page-table__header, typographies-paragraph-medium-bold",
                        rowClassName: "page-table__row",
                        cellClassName: "page-table__cell"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "pages.settings.complianceImpersonate.ComplianceImpersonate.permission_date"
                          ),
                          prop: "accepted-at",
                          className: "page-table__header"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          scope.row.status !== "refused"
                                            ? _vm.formatDate(
                                                scope.row.accepted_at
                                              )
                                            : "-"
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          565766640
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "pages.settings.complianceImpersonate.ComplianceImpersonate.expiration_date"
                          ),
                          prop: "expired-at",
                          className: "page-table__header"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.getDataExpiredAt(scope.row)
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          229943885
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "pages.settings.complianceImpersonate.ComplianceImpersonate.access_type"
                          ),
                          prop: "type",
                          className: "page-table__header"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.formatAccessType(scope.row.type)
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2840816032
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__("common.labels.status"),
                          prop: "status",
                          className: "page-table__header"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "CompassTag",
                                    {
                                      attrs: {
                                        type: "dot",
                                        color: _vm.dotColor(scope.row.status)
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$l10n.__(
                                              _vm.statusText(scope.row.status)
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2255436107
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "",
                          className: "page-table__header",
                          align: "right"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.status === "active"
                                    ? _c("CompassButton", {
                                        ref: "revokeButton",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.actions.revoke_access"
                                          ),
                                          type: "primary-destructive",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRevoke(
                                              scope.row.id
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2505207597
                        )
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "table__empty" },
                    [
                      _c("IllustrationAutorisationIcon", {
                        staticClass: "table__empty--icon"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "typographies-heading-h4" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Aucune autorisation en cours ou passée"
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ],
                    1
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("RevokeDialog", {
        attrs: {
          visible: _vm.displayRevokeConfirmation,
          uuid: _vm.authorizationId
        },
        on: {
          close: _vm.handleClose,
          "revoke-success": _vm.getUserAuthorizations
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }